import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import "../../scripts/ah.mb.client-notifications";

import { bootbox, IBootBoxPrompt } from "../../infrastructure/bootbox-shim";

import { NotificationApiServices, INotificationEditorModel, NotificationSeverity } from "../../scripts/ah.mb.notification-services";
import { ModelLockApi} from "../../scripts/ah.mb.model-lock-services";



@Component
export default class NotificationEditor extends Vue {

    @Prop()
    message: string;

    @Prop()
    severity: string;

    //props: ['message'];

    //data() {

    //    const value: INotificationEditorModel = { severity: "Info", message: "" };

    //    return {
    //        value: value
    //    }

    //}
}



// WEBPACK FOOTER //
// ./ClientApp/components/notifications/notification-editor.ts